import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const ScoringCategoryDetailItemSummary = ({ scoringCategoryDetails, visibleNumeric, scaleFormat }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
        {t('ScoringCategories.Details.Code')} : <span> {scoringCategoryDetails.code} </span>
      </Grid>
      <Grid item xs={12} sm={3}>
        {t('ScoringCategories.Details.ScoringDetailName')} : <span> {scoringCategoryDetails.scoringDetailName} </span>
      </Grid>
      {scoringCategoryDetails.minValue !== null && scoringCategoryDetails.maxValue !== null && visibleNumeric === 2 && (
        <>
          <Grid item xs={12} sm={3}>
            {t('ScoringCategories.Details.Value')} :{' '}
            {scoringCategoryDetails.minValue ? scoringCategoryDetails.minValue.toFixed(scaleFormat) : 0} -{' '}
            {scoringCategoryDetails.maxValue ? scoringCategoryDetails.maxValue.toFixed(scaleFormat) : 0}
          </Grid>
        </>
      )}
    </Grid>
  );
};

ScoringCategoryDetailItemSummary.propTypes = {
  scoringCategoryDetails: PropTypes.object.isRequired,
  scaleFormat: PropTypes.number.isRequired,
  visibleNumeric: PropTypes.number
};

export default ScoringCategoryDetailItemSummary;
